import { useContext } from "react";
import TextEditor from "../../components/Table/TextEditor";
import { context } from "../../context/authContext";
import useActions from "./acciones";

export default function useColumns(setSelectedRow,setModalOpen) {
  const { user } = useContext(context);
  const { handleDelete } = useActions();

  const userRoles = user?.rol || [];
  const permisos = userRoles.find((role) => role.nombre === "Roles")?.permiso || [];
  const isEditable = permisos.includes("editar");
  const canDelete = permisos.includes("borrar");

  return [
    { field: "id", sort: "asc", cellClass: "d-flex align-items-center" },
    ...["nombre", "ruta"].map((field) => ({
      field,
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      editable: isEditable,
      tooltipValueGetter: (params) => params.data?.[`tooltipError${field}`] || "",
      cellClassRules: {
        "is-invalid": (params) => !!params.data?.[`tooltipError${field}`],
        "is-valid": (params) => !!params.data?.[`isValid${field}`],
      },
    })),
    ...["ver", "crear", "editar", "borrar"].map((field) => ({
      field,
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellRenderer: 'agCheckboxCellRenderer',
      cellEditor: "agCheckboxCellEditor",
      editable: isEditable,
    })),
    canDelete && {
      field: "eliminar",
      flex: 2,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button
          onClick={() => handleDelete(data, setSelectedRow, setModalOpen)}
          className="btn btn-primary px-2 py-1"
        >
          🗑️ Eliminar
        </button>
      ),
    },
  ].filter(Boolean); // Remove false values if `canDelete` is false
}